export default __webpack_public_path__ + "static/media/Performance.ffb888ae.gif";